<template>
  <div>
    <CCard>
      <CCardHeader>
        <CIcon name="cil-grid"/> Active Policies
      </CCardHeader>
      <PoliciesTable />
    </CCard> 
  </div>
</template>

<script>
import PoliciesTable from "@/components/CustomersTable"
export default {
  components:{
    PoliciesTable
  }
}
</script>

<style>

</style>